import styled, { keyframes } from 'styled-components';

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing.s}px;
`;

export const StyledCardWrap = styled.div`
  position: relative;
  min-width: 0;

  &:hover button[data-delete],
  &:focus-within button[data-delete] {
    opacity: 1;
  }

  /*
   * Desktop does not mean mouse. On a touchscreen laptop there is no hover, and tapping the
   * card selects the media rather than revealing this control — so delete would be
   * unreachable. Where hover does not exist, the affordance is simply always visible.
   */
  @media (hover: none) {
    button[data-delete] {
      opacity: 1;
    }
  }
`;

export const StyledCard = styled.button`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  width: 100%;
  min-width: 0;
  padding: 0;
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  overflow: hidden;
  cursor: pointer;
  text-align: left;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const StyledDeleteButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacing.xs}px;
  right: ${({ theme }) => theme.spacing.xs}px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.overlay};
  color: ${({ theme }) => theme.colors.textPrimary};
  cursor: pointer;
  opacity: 0;
  transition:
    opacity 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.dangerSurface};
  }
`;

export const StyledThumbWrap = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.surface};
`;

export const StyledThumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const StyledThumbVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const StyledPlayBadge = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.scrimMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${({ theme }) => theme.fontSizes.xs}px;
  padding-left: 2px;
  pointer-events: none;
`;

export const StyledTitle = styled.span`
  padding: 0 ${({ theme }) => theme.spacing.xs}px ${({ theme }) => theme.spacing.xs}px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  padding: ${({ theme }) => theme.spacing.xl}px ${({ theme }) => theme.spacing.m}px;
  text-align: center;
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const StyledSpinner = styled.div`
  width: 22px;
  height: 22px;
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const StyledLoadMore = styled.button`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.s}px;
  padding: ${({ theme }) => theme.spacing.s}px;
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
